import * as z from "zod";

export const getSupportV2MigrationAnalytics = {
  name: "getSupportV2MigrationAnalytics" as const,
  input: z.object({}),
  output: z.object({
    servedTrueCount: z.number().nullable(),
    supportEnabledTeamsCount: z.number(),
    billingAcceptedCount: z.number(),
    remainingCount: z.number().nullable(),
  }),
};
export type SupportV2MigrationAnalytics = z.infer<
  typeof getSupportV2MigrationAnalytics.output
>;
